import { render } from "./ProgressBar.vue?vue&type=template&id=79a9b932"
import script from "./ProgressBar.vue?vue&type=script&lang=ts"
export * from "./ProgressBar.vue?vue&type=script&lang=ts"

import "./ProgressBar.vue?vue&type=style&index=0&id=79a9b932&lang=scss"
script.render = render

export default script